import { useMemo } from "react";
import { useSearchParams } from "react-router";
import FullScreenLoader from "../../components/FullScreenLoader";
import { useGetAutomatedGiftsQuery } from "../../features/automatedGifts/automatedGiftsApi";
import CampaignPanel from "./components/CampaignPanel";
import {
  AUTOMATED_GIFTS_TABS,
  parseAutomatedGiftTab,
} from "./automatedGiftsTabsConfig";
import "./automatedGifts.css";

const AutomatedGiftsPage = () => {
  const [searchParams] = useSearchParams();
  const activeTab = parseAutomatedGiftTab(searchParams.get("tab"));
  const { data, isLoading, isError, refetch } = useGetAutomatedGiftsQuery();

  const payload = data?.data;
  const activeMeta = useMemo(
    () => AUTOMATED_GIFTS_TABS.find((tab) => tab.id === activeTab)!,
    [activeTab],
  );

  const campaign =
    activeTab === "birthday" ? payload?.birthday : payload?.home_anniversary;

  // Same pattern as Dashboard / Profile: only the shared FullScreenLoader on first load.
  if (isLoading) {
    return <FullScreenLoader />;
  }

  if (isError || !payload) {
    return (
      <div className="ag-page">
        <div className="ag-shell">
          <div className="ag-shell-body ag-panel text-center">
            <h2>Couldn't load automated gifts</h2>
            <p className="text-muted mb-3">
              Please try again. Campaigns are created automatically for each user.
            </p>
            <button type="button" className="ag-btn-primary" onClick={() => refetch()}>
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ag-page">
      <div className="ag-shell">
        <div className="ag-shell-body">
          <header className="ag-page-header">
            <h1 className="ag-page-title">{activeMeta.title}</h1>
            <p className="ag-lead-copy">{activeMeta.description}</p>
          </header>
          <CampaignPanel
            type={activeTab}
            campaign={campaign}
            title={activeMeta.title}
            description={activeMeta.description}
            emptyCta={activeMeta.emptyCta}
          />
        </div>
      </div>
    </div>
  );
};

export default AutomatedGiftsPage;
